module.exports = __webpack_public_path__ + "img/bg-mbl-D.89008e1c.png";